import { Dialog, DialogTitle, DialogContent, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { red } from "@mui/material/colors";
import { Alert } from '@mui/material';
import { FC, useCallback, useEffect, useState } from "react";
import { Componente } from 'src/components/componentes/types';
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import defaultListStore from "src/framework/store/DefaultListStore";

const IDS_ITEM_ESTRUTURA = [
    10, 19, 20, 21, 22,
    25, 26, 27, 28, 29,
    34, 35
]

export interface IAddComponente {
    open: boolean;
    categoria?: number;
    // estabelecimento?: number;
    componentesCache: any[];
    notIn?: number[];
    onChangeValue: (componente: Componente) => void;
    onClose: () => void;
}

const AddComponente: FC<IAddComponente> = ({
    open,
    onClose,
    categoria = 0,
    // estabelecimento,
    componentesCache = [],
    notIn = [],
    onChangeValue,
}) => {
    const [searchString, setSearchString] = useState<string>("");
    const [componentList, setComponentList] = useState<Componente[]>([]);

    const handleSingleChange = (componente: Componente): void => {
        const _componente: Componente = componente

        const _c: Componente = {
            id: _componente.id,
            altura: _componente.altura,
            categoria_componentes_id: _componente.categoria_componentes_id,
            comprimento: _componente.comprimento,
            considerar_calculo: _componente.considerar_calculo,
            created_at: _componente.created_at,
            dados_integracao: _componente.dados_integracao,
            descricao: _componente.descricao,
            descricao_comercial: _componente.descricao_comercial,
            exibir_listagem: _componente.exibir_listagem,
            largura: _componente.largura,
            modelo: _componente.modelo,
            nome: _componente.nome,
            nome_comercial: _componente.nome_comercial,
            peso: _componente.peso,
            tempo_garantia: _componente.tempo_garantia,
            tempo_garantia_unidade: _componente.tempo_garantia_unidade,
            grupo_mercadoria: _componente.grupo_mercadoria,
            updated_at: _componente.updated_at,
            fabricante: _componente.fabricante,
            seguimento: _componente.seguimento,
        }


        onChangeValue(_c);
        onClose();

    }

    const handleComponenteList = useCallback((query: string) => {
        let componentes: Componente[] = componentesCache.filter((c) => {
            if (categoria > 0) {
                if (IDS_ITEM_ESTRUTURA.includes(categoria)) {
                    return !notIn.includes(parseInt(`${c.id}`)) && IDS_ITEM_ESTRUTURA.includes(parseInt(`${c.categoria_componentes_id}`))
                }
                return !notIn.includes(parseInt(`${c.id}`)) && categoria == c.categoria_componentes_id
            }
            return notIn.includes(parseInt(`${c.id}`)) == false;
        });

        if (query != "") {
            componentes = componentes.filter((c) => {
                const id = c.id?.toString().toLowerCase() || ""
                const modelo = c.modelo?.toString().toLowerCase() || ""
                const descricao = c.descricao?.toString().toLowerCase() || ""
                if (id.indexOf(query.toLowerCase()) > -1 || modelo.indexOf(query.toLowerCase()) > -1 || descricao.indexOf(query.toLowerCase()) > -1) {
                    return true;
                }
                return false
            })
        }

        setComponentList([...componentes]);
    }, [componentesCache, categoria, notIn]);

    useEffect(() => {
        if (open === true) {
            setSearchString("");
            handleComponenteList("");
        }
    }, [open]);

    return <Dialog
                open={open}
                maxWidth={"lg"}
            >
                <DialogTitle id="simple-dialog-title" style={{ paddingBottom: 0 }}>Novo Componente{/*  ({`${estabelecimento}`}) */}</DialogTitle>
                <DialogContent >
                    <section style={{ minWidth: "600px", maxWidth: "800px" }}>
                        <div className="row">
                            <div className="X12">
                                <InputText
                                    fullWidth
                                    label="Procure por Código, Modelo ou Descrição"
                                    value={searchString}
                                    onChange={(event: any) => {
                                        const value = event.target.value;
                                        handleComponenteList(value.toString());
                                        setSearchString(value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="X12">
                                <TableContainer style={{ maxHeight: "400px" }}>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    {/* <Checkbox /> */}
                                                </TableCell>
                                                <TableCell>
                                                    Código
                                                </TableCell>
                                                <TableCell>
                                                    Modelo
                                                </TableCell>
                                                {/* <TableCell>
                                                    Estabelecimento
                                                </TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {componentList.map((c: any, index: number) => {

                                                return <TableRow key={`add-componente-saldo-funil-${index}`}>
                                                    <TableCell padding="checkbox">
                                                        {/* <Checkbox /> */}
                                                    </TableCell>
                                                    <TableCell>
                                                        <a href="javascript:" style={{ color: "#00a335" }} onClick={() => {
                                                            handleSingleChange(c)
                                                        }}>
                                                            {c.id}
                                                        </a>
                                                    </TableCell>
                                                    <TableCell style={{ color: c.considerar_calculo ? "inherit" : red[500] }}>{c.modelo}</TableCell>
                                                </TableRow>
                                            })}
                                        </TableBody>
                                    </Table>

                                </TableContainer>

                            </div>
                        </div>
                        <div className="row">
                            <div className="X12" style={{ textAlign: "right" }}>
                                <span style={{
                                    fontSize: "10px"
                                }}>
                                    {componentList.length}/{defaultListStore.componentes.length}
                                </span>
                            </div>
                        </div>
                        <div className="row X--reverse" style={{ textAlign: "right", paddingTop: "10px", paddingBottom: "7px" }}>
                            <div className="X12">

                                <FlatButton
                                    disableElevation={true}
                                    text={"Cancelar"}
                                    color={"secondary"}
                                    onClick={() => {
                                        onClose();
                                    }}
                                />


                                {/* <FlatButton
                                    disableElevation={true}
                                    text={"Adicionar"}
                                    color={"primary"}
                                    variant={"contained"}
                                    onClick={() => {
                                        onClose();
                                    }}
                                /> */}
                            </div>
                        </div>
                    </section>
                </DialogContent>
            </Dialog>
}

export { AddComponente } 